module.exports = __webpack_public_path__ + "media/project_health_check/browser/MainPage/images/gdpr-icon-294a1d0d7a89f9421885df0a92db29c3.svg";